import { defineComponent as _defineComponent } from 'vue'
import bugsnagClient from 'JS/global/bugsnag';
import CarouselTrackingService from 'JS/services/CarouselTrackingService';
import CartSidebarPrice from './CartSidebarPrice.vue';
import ProductService, { AddToCartResult, IAddToCartPriceJson, IPDPAddToCartResponse } from 'JS/services/ProductService';
import UiButton from 'JS/components/UiButton.vue';
import { computed, ref } from 'vue';
import { createCarouselClickData, createCarouselClickGtmData } from 'JS/utilities/carousel-tracking';
import { FulfillmentType } from 'JS/types/ProductDelivery';
import { IProductCarousel, IProductCarouselProduct } from 'JS/types/Carousel';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuickAddProductDetails',
  props: {
    carousel: null,
    product: null,
    fulfillmentType: null,
    loading: { type: Boolean },
    viewImpressionUrl: null
  },
  emits: ["loading", "maxhit"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'loading', loading: boolean): void,
	(e: 'maxhit'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	carousel: IProductCarousel,
	product: IProductCarouselProduct,
	fulfillmentType: FulfillmentType,
	loading: boolean,
	viewImpressionUrl: string
}



const productService = new ProductService();
const productAdded = ref<boolean>(false);
const productAddError = ref<boolean>(false);
const addToCartText = computed<string>(() => productAddError.value ? 'TRY AGAIN' : 'ADD TO CART');
const _trackingSvc = new CarouselTrackingService();
const priceModel = computed<IAddToCartPriceJson>(() =>{
	const price: IAddToCartPriceJson = {
		qty: 1,
		eachPrice: props.product.price.price,
		originalTotalPrice: props.product.price.originalPrice,
		price: props.product.price,
		lineTotal: props.product.price.currentPrice,
		isFree: false, //quick-add products do not evaluate promos
		isRewardsMemberPrice: false,
		isSpecialOfferPrice: false
	};
	return price;
});



function navigateToPdp(): void {
	window.location.href = props.product.productUrl;
}

async function addToCart(): Promise<void> {
	emit('loading', true);

	if (props.viewImpressionUrl) {

		const clickData = createCarouselClickData(
			props.product,
			props.carousel,
			null,
			props.viewImpressionUrl
		);

		const gtmData = createCarouselClickGtmData(props.product, props.carousel);

		_trackingSvc.trackClick(clickData, gtmData); //Track 'carousel' clickthrough
			
	}

	const response: IPDPAddToCartResponse = await productService.addToCart({
		blainNumber: props.product.blainNumber,
		qty: 1,
		fulfillmentType: props.fulfillmentType,
		userConfirmed: true,
		userAgreed: false, // quick add products should not have a product agreement in the first place
		updateSubscriptionRequest: null,
		skipUpsell: true
	});

	addToCartResponse(response);
}


function addToCartResponse(res: IPDPAddToCartResponse): void {
	if (res == null) {
		productAddError.value = true;
		emit('loading', false);
		return;
	}

	if (res.result == AddToCartResult.MaxLines) {
		emit('maxhit');
		productAddError.value = false;
		emit('loading', false);
		return;
	} else if (res.result != AddToCartResult.Success) {
		if (res.result != AddToCartResult.CannotAdd) {
			//shouldn't be able to reach this, fulfillment type errors shouldn't occur here
			bugsnagClient.notify(new Error('Error type should be unreachable when adding upsell product to cart from pdp.'),  {
				metaData: res
			});
		}
		productAddError.value = true;
	}

	// if response is successful show added to cart modal by setting addingToCart to false
	if (res.result == AddToCartResult.Success) {
		// if cartSummary, update header with new cart data
		updateHeader(res.cartSummary);
		productAdded.value = true;
		productAddError.value = false;
		const cartProduct = res.cartSummary.productsInCart.find(cartProduct => cartProduct.blainNumber === props.product.blainNumber);
		// Add to Cart event for Google Tag Manager
		const orderProducts = res.cartSummary.productsInCart.map(item => ({
			blainNumber: item.price.blainNumber,
			qty: item.qty,
			unitPrice: item.price.price,
			vendorBrand: item.vendorBrand,
			productName: item.productName,
			imageUrl: item.imageUrlLarger,
			productUrl: item.virtualURL
		}));

		window.blainGtmDataLayer.push({ orderProducts: null }); // orderProducts needs to be reset first to avoid conflicts
		window.blainGtmDataLayer.push({
			'blainNumber': props.product.blainNumber,
			'vendorBrand': props.product.vendorBrand,
			'productName': props.product.productName,
			'deliveryChannel': props.fulfillmentType,
			'totalValue': cartProduct.unitPrice,
			'qty': 1,
			'orderProducts': orderProducts,
			'orderId': res.orderID,
			'event': "cart_ajax_add"
		});
	}

	emit('loading', false);
}


function updateHeader(cartSummary): void {
	if (window.vueEventBus && cartSummary) {
		window.vueEventBus.$emit('update-quick-cart', cartSummary);
	}
}


return { __sfc: true,props, productService, productAdded, productAddError, addToCartText, _trackingSvc, priceModel, emit, navigateToPdp, addToCart, addToCartResponse, updateHeader, CartSidebarPrice, UiButton }
}

})